// Shared navigation only. Native <details> remains usable without JavaScript.
(() => {
  'use strict';
  if (window.GoliNavigationReady) return;
  window.GoliNavigationReady = true;
  // Only the masthead stays pinned; categories remain in the document flow.
  const placeCategories = () => {
    const header = document.getElementById('site-header');
    const categories = header?.querySelector('.goli-header-categories');
    if (!categories) return;
    const owner = categories.closest('[id^="shopify-section-"]')?.id || header.id;
    document.querySelectorAll('.goli-header-categories[data-goli-category-owner]').forEach(existing => {
      if (existing !== categories && existing.dataset.goliCategoryOwner === owner) existing.remove();
    });
    categories.dataset.goliCategoryOwner = owner;
    header.after(categories);
  };
  placeCategories();
  document.addEventListener('shopify:section:load', placeCategories);
  const selector = '.main-nav details[data-goli-nav-menu]';
  const menus = () => Array.from(document.querySelectorAll(selector));
  const closeOthers = current => menus().forEach(menu => { if (menu !== current) menu.open = false; });
  document.addEventListener('toggle', event => {
    if (event.target.matches?.(selector) && event.target.open) closeOthers(event.target);
  }, true);
  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : event.target.parentElement;
    const current = target?.closest(selector);
    closeOthers(current);
    if (current && target.closest('[data-goli-nav-panel] a')) current.open = false;
  });
  document.addEventListener('keydown', event => {
    const target = event.target;
    if (event.key === 'Escape') {
      const current = target.closest?.(selector);
      closeOthers(null);
      if (current) { event.preventDefault(); current.querySelector('summary')?.focus(); }
      return;
    }
    const current = target.closest?.(selector);
    if (!current) return;
    const links = Array.from(current.querySelectorAll('[data-goli-nav-panel] a[href]'));
    if (!links.length) return;
    const summary = target.matches('summary');
    if (summary && ['ArrowDown', 'ArrowUp'].includes(event.key)) {
      event.preventDefault(); closeOthers(current); current.open = true;
      (event.key === 'ArrowDown' ? links[0] : links.at(-1)).focus();
    } else if (current.open && !summary && ['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) {
      event.preventDefault();
      const index = links.indexOf(target);
      const next = event.key === 'Home' ? 0 : event.key === 'End' ? links.length - 1 : (index + (event.key === 'ArrowDown' ? 1 : -1) + links.length) % links.length;
      links[next].focus();
    }
  });
  document.addEventListener('focusout', event => {
    const current = event.target.closest?.(selector);
    if (current && event.relatedTarget && !current.contains(event.relatedTarget)) current.open = false;
  });
  document.addEventListener('shopify:section:unload', event => {
    menus().forEach(menu => { if (event.target.contains(menu)) menu.open = false; });
    document.querySelectorAll('.goli-header-categories[data-goli-category-owner]').forEach(categories => {
      if (categories.dataset.goliCategoryOwner === event.target.id) categories.remove();
    });
  });
})();
